import React from 'react';
import image from '../../project images/about us/404-error-isometric-landing-banner-website-maintenance-page-found-concept-with-traffic-cones-sign-construction.jpg'

const PageNotFound = () => {
    return (
        <div>
            <div className="container">
                <img className="w-75 ms-5 my-5" src="https://i.ibb.co/9nvNbQT/not-found-gd24a63f77-1920.jpg" alt="" />
            </div>
        </div>
    );
};

export default PageNotFound;